export const USER_ROLE = {
	SUPER_ADMIN: "Super Admin",
	ADMIN: "Admin",
	STORE_KEEPER: "Store Keeper",
	CUSTOMER_SERVICE: "Customer Service",
	RETAILER: "Retailer",
}

/* Role codes, which is what the server keys access off. Unlike the display names
   above these never change, even when the client renames a role. */
export const ROLE_CODE = {
	SUPER_ADMIN: "superadmin",
	ADMIN: "admin",
	STORE_KEEPER: "store_keeper",
	CUSTOMER_SERVICE: "customer_service",
	RETAILER: "retailer",
}

/* The portal has exactly two shells: the retailer console and the back office.
   Anything that is not a Retailer gets the back office -- so a fifth role invented
   from Roles & Permissions needs no frontend release. WHAT it can reach inside the
   back office is decided by permissions, never by this check. */
export const isStaffRole = (loggedInUser) => {
	if (!loggedInUser) return false;
	const code = loggedInUser.roleCode;
	if (code) return code !== ROLE_CODE.RETAILER;
	// Pre-RBAC sessions have no roleCode; fall back to the display name.
	return loggedInUser.roleName !== USER_ROLE.RETAILER;
}
